<script setup>
import { computed, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import WahaConnectionStatus from './WahaConnectionStatus.vue';

const props = defineProps({
  inbox: { type: Object, required: true },
});

const { t } = useI18n();
const store = useStore();
const router = useRouter();
const dialogRef = ref(null);
const currentUser = useMapGetter('getCurrentUser');
const accountId = useMapGetter('getCurrentAccountId');

const isAdmin = computed(() => currentUser.value?.role === 'administrator');
const storeInbox = computed(() =>
  store.getters['inboxes/getInbox'](props.inbox.id)
);
const connected = computed(() => !!storeInbox.value?.waha?.connected);
const subtitle = computed(() =>
  connected.value
    ? t('INBOX_MGMT.ADD.WHATSAPP.WAHA.SETTINGS.SUBTITLE_CONNECTED')
    : t('INBOX_MGMT.ADD.WHATSAPP.WAHA.SETTINGS.SUBTITLE')
);

watch(connected, isConnected => {
  if (isConnected) dialogRef.value?.close();
});

const open = () => dialogRef.value?.open();
const close = () => dialogRef.value?.close();

const goToSettings = () => {
  if (!isAdmin.value) return;

  close();
  router.push({
    name: 'settings_inbox_show',
    params: {
      accountId: accountId.value,
      inboxId: props.inbox.id,
      tab: 'integration',
    },
  });
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    width="xl"
    overflow-y-auto
    :title="$t('INBOX_MGMT.ADD.WHATSAPP.WAHA.SETTINGS.TITLE')"
    :description="subtitle"
    :cancel-button-label="$t('GENERAL.CLOSE')"
    :confirm-button-label="$t('SIDEBAR.SETTINGS')"
    :show-confirm-button="isAdmin"
    @confirm="goToSettings"
  >
    <WahaConnectionStatus :inbox="inbox" />
  </Dialog>
</template>
